import { Link } from 'react-router-dom';

export default function FiveBanner() {
  return (
    <div
      className="flex items-stretch rounded-lg overflow-hidden"
      style={{ border: '1px solid #e5e5e5', background: '#ffffff' }}
    >
      {/* Red accent stripe */}
      <div style={{ width: 6, background: '#e00000', flexShrink: 0 }} />

      <div className="flex-1 flex flex-col gap-4 px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6 sm:px-6 sm:py-5">
        <div className="flex items-start gap-3">
          {/* FIVE badge */}
          <span
            className="text-xs font-black px-2 py-1 rounded flex-shrink-0 mt-0.5"
            style={{ background: '#e00000', color: '#ffffff', letterSpacing: '0.04em' }}
          >
            FIVE
          </span>
          <div>
            <p className="font-semibold text-sm mb-0.5" style={{ color: '#0b0d0e' }}>
              3-year System Guarantee
            </p>
            <p className="text-xs" style={{ color: '#8f9b9b', maxWidth: 460 }}>
              Register with Original MontiPower components to unlock 3 years of protection across tool, belt, performance, certification and traceability.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3 flex-shrink-0">
          <Link
            to="/five"
            className="text-xs font-semibold px-3 py-1.5 rounded-lg"
            style={{ background: '#f4f4f4', color: '#0b0d0e', border: '1px solid #e5e5e5', textDecoration: 'none', whiteSpace: 'nowrap' }}
          >
            Learn more →
          </Link>
          <Link
            to="/registrations/new"
            className="text-xs font-semibold px-3 py-1.5 rounded-lg"
            style={{ background: '#e00000', color: '#ffffff', textDecoration: 'none', whiteSpace: 'nowrap' }}
          >
            + Register product
          </Link>
        </div>
      </div>
    </div>
  );
}
